<template>
  <b-row>
    <b-col cols="12" lg="12">
      <p v-if="loading" style="text-align: center;padding: 20px">
        <span style="font-size: 25px;">
            <i class="fa fa-spinner fa-spin"></i> Loading...
        </span>
      </p>
      <div v-else>
        <b-card :header="`${user_details.first_name} ${user_details.last_name} Details`"> 
          <b-row>
            <b-col lg="3" md="3" sm="12" xs="12">
              <p class="text-center" title="Click to change photo">
                  <img v-if="user_details.profile_image === null" src="@/assets/images/man.png" alt="profile-image" />
                  <img v-else-if="user_details.profile_image !== ''" :src="user_details.profile_image" alt="profile-image" class="rounded-circle img-response" width="150"/>
                  <img v-else src="@/assets/images/man.png" alt="profile-image" />
              </p>
              <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                      <strong>{{`${user_details.first_name} ${user_details.last_name}`}}</strong>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                      <strong>Status:</strong>
                      <b-badge v-if="user_details.is_active === 1" variant="success" pill>Active</b-badge>
                      <b-badge v-else variant="warning" pill>Inactive</b-badge>
                  </b-list-group-item>
              </b-list-group><br/>
              <b-card header="Change Password">
                <b-row>
                  <b-col cols="12" lg="12" md="12" sm="12">
                    <form @submit.prevent="changePassword">
                      <b-form-group label="New Password">
                        <input class="form-control" type="password" v-model="password" placeholder="New password here..."/>
                      </b-form-group>
                      <b-form-group label="Confirm Password">
                        <input class="form-control" type="password" v-model="c_password" placeholder="Confirm new password..."/>
                      </b-form-group>
                      <b-form-group>
                        <button class="btn btn-md btn-success form-control" type="submit">Change Password</button>
                      </b-form-group>
                    </form>
                  </b-col>
                </b-row>
              </b-card>
          </b-col>
          <b-col lg="9" md="9" sm="12" xs="12">
            <b-card header="Personal Information">
              <form @submit.prevent="updateUserDetails">
              <b-row>
                <b-col lg="12" md="12" sm="12" xs="12">
                  <b-form-group label="First Name">
                    <input class="form-control" type="text" v-model="user_details.first_name" />
                  </b-form-group>
                  <b-form-group label="Last Name">
                    <input class="form-control" type="text" v-model="user_details.last_name" />
                  </b-form-group>
                  <b-form-group label="Email Address">
                    <input type="email" class="form-control" v-model="user_details.email" />
                  </b-form-group>
                  <b-form-group label="Phone Number">
                    <input type="text" class="form-control" v-model="user_details.telephone" />
                  </b-form-group>
                  <b-form-group label="Role" label-for="normalPass">
                    <select v-model="role" class="form-control">
                      <option value="">---select loan type---</option>
                      <option v-for="(type, index) in roles" v-bind:key="index" :value="type.name">{{type.label}}</option>
                    </select>
                  </b-form-group><hr/>
                  <b-form-group>
                    <b-button type="button" class="pull-right" variant="success" v-if="isLoading" disabled>
                      <i class="fa fa-spinner fa-spin"></i> Please wait...
                    </b-button>
                    <b-button type="submit" variant="primary" class="btn-md btn-success pull-right" v-else>
                      <i class="fa fa-send"></i> Update
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
              </form>
            </b-card>
            <b-card header="Activity Logs">
              <b-row></b-row>
            </b-card>
          </b-col>
          </b-row>
          <template slot="footer">
            <b-button @click="goBack">Back</b-button>
          </template>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { baseURL } from '@/shared/utils'

export default {
  name: 'User',
  data: () => {
    return {
      user_details: {},
      loading: false,
      role: '',
      roles: [],
      isLoading: false,
      password: '',
      c_password: ''
    }
  },
  created() {
    this.getUserDetails();
    this.getRoles();
  },
  methods: {
    getUserDetails() {
      this.loading = true;
      const user_id = this.$route.params.id
      this.$http.get(`${baseURL}user/${user_id}`)
      .then(response => {
        console.log(JSON.stringify(response.data));
        this.loading = false;
        this.user_details = response.data.user;
      })
      .catch(function (error) {
        this.loading = false;
      });
    },
    getRoles() {
      this.$http.get(`${baseURL}roles`)
      .then(({data}) => {
        let roles = data.datas.filter(role => role.name !== 'customer');
        this.roles = roles;
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    updateUserDetails() {
      const user_id = this.$route.params.id;
      this.isLoading = true;
      this.$http.post(`${baseURL}user/${user_id}`, {
        first_name: this.user_details.first_name,
        last_name: this.user_details.last_name,
        email: this.user_details.email,
        roles: this.role,
        telephone: this.user_details.telephone
      })
      .then(({data}) => {
        this.user_details = data.user;
        this.isLoading = false;
        this.$swal('Updated Successfully', 'User profile updated successfully.', 'success');
      })
      .catch((error) => {
        this.isLoading = false;
        this.$swal('Error!', 'Something went wrong', 'error');
      })
    },
    changePassword() {

    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
